/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UserFulfillmentRequest = {
  /**
   * List of preparer IDs to filter fulfillments. At least one preparer ID is required.
   */
  preparer_ids?: Array<number>;
  /**
   * List of reviewer IDs to filter fulfillments. At least one reviewer ID is required.
   */
  reviewer_ids?: Array<number>;
  /**
   * Filter by fulfillment status: 'current' for non-completed, 'past' for completed, 'unassigned' for models with no reviewers/preparers, 'all' for all fulfillments
   */
  status_filter?: UserFulfillmentRequest.status_filter;
  /**
   * Multiple status filters combined with OR logic. Overrides status_filter when provided.
   */
  status_filters?: Array<'current' | 'past' | 'unassigned' | 'all'>;
  /**
   * Filter by specific model_status numeric values (0=Draft, 1=Review, 2=In-process, 3=Final, 4=Review Final, 5=Complete).
   */
  model_statuses?: Array<number>;
  from_date?: string | null;
  to_date?: string | null;
  company?: string | null;
  page?: number | null;
  page_size?: number;
};
export namespace UserFulfillmentRequest {
  /**
   * Filter by fulfillment status: 'current' for non-completed, 'past' for completed, 'unassigned' for models with no reviewers/preparers, 'all' for all fulfillments
   */
  export enum status_filter {
    CURRENT = 'current',
    PAST = 'past',
    UNASSIGNED = 'unassigned',
    ALL = 'all',
  }
}
